"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSocialShare = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-console */
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const react_1 = require("react");
const GoogleAnalyticsService_1 = require("../../services/analytics/GoogleAnalyticsService");
const utils_1 = require("../../utils");
const fetchImage = (image) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield (0, utils_1.fetchImageFileByUrl)(image);
    }
    catch (e) {
        return null;
    }
});
const ModalSocialShare = ({ text, open, imageUrl, onClose }) => {
    const [file, setFile] = (0, react_1.useState)(null);
    const [isCopied, setIsCopied] = (0, react_1.useState)(false);
    const handleOnClickCloseButton = () => {
        GoogleAnalyticsService_1.GoogleAnalyticsService.event({
            event: 'event',
            eventCategory: `minhaloja:${(0, utils_1.getBrandName)()}:geral`,
            eventAction: 'click:button',
            eventLabel: 'modal-compartilhar:fechar',
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleOnCopyText = () => __awaiter(void 0, void 0, void 0, function* () {
        GoogleAnalyticsService_1.GoogleAnalyticsService.event({
            event: 'event',
            eventCategory: `minhaloja:${(0, utils_1.getBrandName)()}:geral`,
            eventAction: 'click:button',
            eventLabel: 'modal-compartilhar:copiar-texto',
        });
        try {
            yield (0, utils_1.copyTextToClipboard)(text);
            GoogleAnalyticsService_1.GoogleAnalyticsService.event({
                event: 'event',
                eventCategory: `minhaloja:${(0, utils_1.getBrandName)()}:geral`,
                eventAction: 'click:button',
                eventLabel: 'acesso-copiar:sucesso',
            });
            setIsCopied(true);
        }
        catch (error) {
            GoogleAnalyticsService_1.GoogleAnalyticsService.event({
                event: 'event',
                eventCategory: `minhaloja:${(0, utils_1.getBrandName)()}:geral`,
                eventAction: 'click:button',
                eventLabel: 'acesso-copiar:negado',
            });
        }
    });
    const handleOnClickShareButton = () => __awaiter(void 0, void 0, void 0, function* () {
        GoogleAnalyticsService_1.GoogleAnalyticsService.event({
            event: 'event',
            eventCategory: `minhaloja:${(0, utils_1.getBrandName)()}:geral`,
            eventAction: 'click:button',
            eventLabel: 'modal-compartilhar:compartilhar',
        });
        const shareData = imageUrl && file ? { files: [file] } : { text: text };
        yield (0, utils_1.shareNatively)(shareData);
    });
    (0, react_1.useEffect)(() => {
        const getFile = () => __awaiter(void 0, void 0, void 0, function* () {
            if (imageUrl == null) {
                throw new Error('imageUrl should not be null');
            }
            const fileLocal = yield fetchImage(imageUrl);
            if (!fileLocal) {
                return;
            }
            setFile(fileLocal);
        });
        if (imageUrl != null) {
            getFile();
        }
    }, [imageUrl]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Modal, Object.assign({ open: open }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.ModalContent, Object.assign({ size: "standard" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.ModalCloseButton, { onClick: handleOnClickCloseButton }), (0, jsx_runtime_1.jsx)(flora_react_1.ModalHeader, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Heading, Object.assign({ level: 6, as: "h1", css: {
                            fontWeight: '$medium',
                            paddingBottom: '$4',
                            borderBottom: '1px solid #ccc',
                        } }, { children: "Compartilhar" })) }), (0, jsx_runtime_1.jsxs)(flora_react_1.ModalBody, { children: [imageUrl != null ? ((0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ direction: "column" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyMediumShort", weight: "medium", css: { paddingTop: '$4' } }, { children: "Pr\u00E9-visualiza\u00E7\u00E3o:" })), (0, jsx_runtime_1.jsx)(flora_react_1.Image, { src: imageUrl, alt: "", width: 80, height: 110, css: { margin: '0 auto', padding: '$2 0' }, id: "shareImageId" })] }))) : null, (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { width: 'calc(100% - $14)', paddingRight: '$1' } }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ direction: "column", align: "flex-start", css: {
                                            padding: '8px 12px',
                                            borderRadius: '4px',
                                            border: '2px solid $actionSuccessStatic',
                                        } }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "exceptionsAuxiliarRegular" }, { children: "Texto e Link:" })), (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyMediumShort", weight: "medium", css: {
                                                    overflow: 'hidden',
                                                    width: '100%',
                                                    wordBreak: 'break-word',
                                                } }, { children: text }))] })) })), (0, jsx_runtime_1.jsxs)(flora_react_1.Button, Object.assign({ variant: "standard", onClick: handleOnCopyText, "autotagging-flora": "on", "aria-label": "Copiar texto para \u00E1rea de transfer\u00EAncia" }, { children: ["Copiar", (0, jsx_runtime_1.jsx)(flora_react_icons_1.TwoPiledSquaresIcon, { css: { marginLeft: '$2' } })] }))] })), isCopied ? ((0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ css: { marginTop: '$2' } }, { children: [(0, jsx_runtime_1.jsx)(flora_react_icons_1.CheckCircleFillIcon, { color: "$actionSuccessStatic" }), (0, jsx_runtime_1.jsx)(flora_react_1.Text, { children: "Copiado para sua \u00E1rea de transfer\u00EAncia" })] }))) : null] }), (0, jsx_runtime_1.jsx)(flora_react_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ isFull: true, variant: "conversion", onClick: handleOnClickShareButton, "autotagging-flora": "on" }, { children: "Escolher onde compartilhar" })) })] })) })));
};
exports.ModalSocialShare = ModalSocialShare;
